import React, { useEffect, useState } from "react"
import {
  Button,
  DatePicker,
  TimePicker,
  Dropdown,
  Input,
  Select,
  Space,
  Table,
  Checkbox,
} from "antd"
import { DownOutlined, SearchOutlined } from "@ant-design/icons"
import { useDispatch, useSelector } from "react-redux"
import {
  getClubs,
  getRoles,
  getTrainerTypes,
  getClubTypes,
  getManagers,
  getPaymentSystem,
  getTrainers,
  getGyms,
} from "src/store/Slices/DropDownSlice"
import { useLocation } from "react-router-dom"
import { useRef } from "react"
import dayjs from "dayjs"
import {
  getAbonementTypes,
  getServices,
} from "src/store/Slices/AbonementsSlice"
import { getAbonements, getAbonementsList } from "src/store/Slices/ClientsSlice"
import { passagesAction } from "src/store/Slices/Administrator/PassagesSlice"
import TimelineItem from "antd/es/timeline/TimelineItem"

const { RangePicker } = DatePicker

const AdminTable = ({
  loading,
  columns,
  rows,
  title,
  setPage,
  setPageSize,
  page,
  total,
  onClickRowOne,
  pageSize,
  onChange,
  rowClassName,
  items = [],
  isDeleted,
  scroll,
  checkers,
  setClientMarkedList,
  allActive,
  setAllActive,
  clientMarkedList,
  searchble = true,
  height = 600,
  setNullMarkedClients,
}) => {
  // HELPERS
  const dispatch = useDispatch()
  const location = useLocation()
  const options = [
    { label: "Да", value: true },
    { label: "Нет", value: false },
  ]

  const success = [
    { label: "Успешно", value: true },
    { label: "Безуспешно", value: false },
  ]

  const types = [
    { label: "Кнопка", value: 1 },
    { label: "Face Id", value: 2 },
  ]

  const date = new Date()
  const addZero = (num) => (num < 10 ? "0" + num : num)
  const today = `${date.getFullYear()}-${addZero(
    date.getMonth() + 1,
  )}-${addZero(date.getDate())}`
  const yesNoOpt = [
    { value: true, label: "Да" },
    { value: false, label: "Нет" },
  ]

  // STORE
  const trainerTypes = useSelector((state) => state.DropDownSlice.trainerTypes)
  const clubs = useSelector((state) => state.DropDownSlice.clubs)
  const gyms = useSelector((state) => state.DropDownSlice.gyms)
  const trainersList = useSelector((state) => state.DropDownSlice.trainersList)
  const services = useSelector((state) => state.DropDownSlice.services)
  const managersList = useSelector((state) => state.DropDownSlice.managersList)
  const clubTypes = useSelector((state) => state.DropDownSlice.clubTypes)
  const roles = useSelector((state) => state.DropDownSlice.roles)
  const paymentSystems = useSelector(
    (state) => state.DropDownSlice.paymentSystems,
  )
  const abonementServices = useSelector(
    (state) => state.AbonementsSlice.abonementServices,
  )
  const abonementsList = useSelector(
    (state) => state.ClientsSlice.abonementsList,
  )
  const abonements = useSelector((state) => state.ClientsSlice.abonements)

  const searchInput = useRef()
  // ОЧИЩЕНИЕ ФИЛЬТРОВ
  const handleReset = (clearFilters, confirm) => {
    clearFilters()
    confirm()
  }

  useEffect(() => {
    if (columns?.data?.value?.columns) {
      const columnTitles = columns.data.value.columns.map((col) => col.title)
      console.log("All column titles:", columnTitles)

      // Вывести подробную информацию о каждой колонке
      columns.data.value.columns.forEach((col, index) => {
        console.log(`Column ${index + 1}:`, {
          title: col.title,
          dataIndex: col.dataIndex,
          hasSorter: !!col.sorter,
        })
      })
    }
  }, [columns])

  // ФИЛЬТРЫ
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        {location.pathname === "/clients" && (
          <div>
            {title !== "№" &&
              title !== "Дата рождения" &&
              title !== "Клуб" &&
              title !== "Абонемент" &&
              title !== "Абонемент С" &&
              title !== "Абонемент До" &&
              title !== "Заморожен До" &&
              title !== "Заморожен" &&
              title !== "Персональная" &&
              title !== "Действует С" &&
              title !== "Действует До" &&
              title !== "Осталось" &&
              title !== "Дней заморозки" &&
              title !== "Дата контакта" &&
              title !== "Цена покупки" &&
              title !== "Дата последней покупки" &&
              title !== "Задача" &&
              title !== "Выполнена" &&
              title !== "Менеджер" &&
              title !== "Дата транзакции" &&
              title !== "Дата начала абонемента" &&
              title !== "Дата конца абонемента" &&
              title !== "Добавленных дней" &&
              title !== "Дата создания ссылки" &&
              title !== "Блокировка" &&
              title !== "Платежная система" && (
                <Input
                  ref={searchInput}
                  placeholder={`Искать ${title}`}
                  value={selectedKeys[0]}
                  onChange={(e) =>
                    setSelectedKeys(e.target.value ? [e.target.value] : [])
                  }
                  onPressEnter={() => confirm()}
                  style={{
                    marginBottom: 8,
                    display: "block",
                  }}
                />
              )}
            {title === "Дата рождения" && (
              <RangePicker
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Абонемент С" && (
              <RangePicker
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Блокировка" && (
              <Select
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Платежная система" && (
              <Select
                onClick={() => {
                  dispatch(getPaymentSystem())
                }} //надо поставить фильтр
                style={{ width: "100%", marginBottom: "8px" }}
                options={paymentSystems?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Абонемент До" && (
              <RangePicker
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Действует С" && (
              <RangePicker
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Длительность" && <div style={{ width: "400px" }}></div>}
            {title === "Действует До" && (
              <RangePicker
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Заморожен До" && (
              <RangePicker
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Абонемент" && (
              <Select
                onClick={() => {
                  dispatch(getAbonementsList())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={abonementsList?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Заморожен" && (
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                options={options}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Персональная" && (
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                options={options}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {(title === "№" ||
              title === "Осталось" ||
              title === "Дней заморозки") && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Добавленных дней" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Тип" && (
              <Select
                onClick={() => {
                  dispatch(getTrainerTypes())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={trainerTypes?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder={`Выбрать ${title.toLowerCase()}`}
              />
            )}
            {title === "Менеджер" && (
              <Select
                onClick={() => {
                  dispatch(getManagers(), console.log(selectedKeys[0]))
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={managersList?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder={`Выбрать ${title.toLowerCase()}`}
              />
            )}
            {title === "Дата контакта" && (
              <RangePicker
                placeholder={`Выбрать дату`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Дата транзакции" && (
              <RangePicker
                placeholder={`Выбрать дату`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Дата начала абонемента" && (
              <RangePicker
                placeholder={`Выбрать дату`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Дата конца абонемента" && (
              <RangePicker
                placeholder={`Выбрать дату`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Задача" && (
              <RangePicker
                placeholder={`Выбрать дату`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Цена покупки" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Выполнена" && (
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                options={options}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Дата последней покупки" && (
              <RangePicker
                placeholder={`Выбрать дату`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Дата создания ссылки" && (
              <RangePicker
                placeholder={`Выбрать дату`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
          </div>
        )}

        {location.pathname === "/admin/trainers" && (
          <div>
            {title !== "№" && title !== "Тип" && title !== "Клуб" && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Тип" && (
              <Select
                onClick={() => {
                  dispatch(getTrainerTypes())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={trainerTypes?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
          </div>
        )}

        {location.pathname === "/admin/paymentsToTrainers" && (
          <div>
            {title !== "№" && title !== "ФИО тренера" && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}

            {title === "ФИО тренера" && (
              <Select
                onClick={() => {
                  dispatch(getTrainers())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={trainersList?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
                onClear={() => {
                  setSelectedKeys([])
                  // setTimeout(() => confirm(), 0)
                }}
              />
            )}
          </div>
        )}

        {location.pathname === "/admin/passages" && (
          <div>
            {title !== "№" &&
              title !== "Статус" &&
              title !== "Дата" &&
              title !== "Тип" &&
              title !== "Клуб" && (
                <Input
                  ref={searchInput}
                  placeholder={`Искать ${title}`}
                  value={selectedKeys[0]}
                  onChange={(e) =>
                    setSelectedKeys(e.target.value ? [e.target.value] : [])
                  }
                  onPressEnter={() => confirm()}
                  style={{
                    marginBottom: 8,
                    display: "block",
                  }}
                />
              )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Статус" && (
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                options={success}
                onChange={(e) => {
                  setSelectedKeys([e])
                }}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Дата" && (
              <RangePicker
                placeholder={today}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}

            {title === "Тип" && (
              <Select
                onClick={() => {
                  dispatch(
                    passagesAction({
                      flag: "get",
                      value: `Type: ${selectedKeys}`,
                    }),
                  )
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={types}
                onChange={(e) => {
                  setSelectedKeys([e])
                }}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
          </div>
        )}

        {location.pathname === "/admin/trainingRecords" && (
          <div>
            {title !== "№" &&
              title !== "Время" &&
              title !== "Дата" &&
              title !== "Тренер" &&
              title !== "Услуга" &&
              title !== "Зал" &&
              title !== "Клуб" && (
                <Input
                  ref={searchInput}
                  placeholder={`Искать ${title}`}
                  value={selectedKeys[0]}
                  onChange={(e) =>
                    setSelectedKeys(e.target.value ? [e.target.value] : [])
                  }
                  onPressEnter={() => confirm()}
                  style={{
                    marginBottom: 8,
                    display: "block",
                  }}
                />
              )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Дата" && (
              <RangePicker
                placeholder={today}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Время" && (
              <div style={{ display: "flex", gap: "10px" }}>
                <TimePicker
                  placeholder={`Время от`}
                  onChange={(e) => {
                    const fromValue = e
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                  onPressEnter={() => confirm()}
                  style={{
                    marginBottom: 8,
                    width: "100%",
                  }}
                  format={"HH:mm"}
                />
                <TimePicker
                  disabled={!selectedKeys[0]}
                  placeholder={`Время до`}
                  onChange={(e) => {
                    const toValue = e
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                  onPressEnter={() => confirm()}
                  style={{
                    marginBottom: 8,
                    width: "100%",
                  }}
                  format={"HH:mm"}
                />
              </div>
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}

            {title === "Тренер" && (
              <Select
                //labelInValue
                onClick={() => {
                  dispatch(getTrainers())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={trainersList?.data?.value}
                onChange={(value) => setSelectedKeys([value])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Зал" && (
              <Select
                onClick={() => {
                  dispatch(getGyms())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={gyms?.data?.value}
                onChange={(option) => setSelectedKeys([option])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Услуга" && (
              <Select
                onClick={() => {
                  dispatch(getServices())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={abonementServices?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
          </div>
        )}

        {location.pathname === "/admin/clubs" && (
          <div>
            {title !== "№" && title !== "Тип" && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Тип" && (
              <Select
                onClick={() => {
                  dispatch(getClubTypes())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubTypes?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
          </div>
        )}

        {location.pathname === "/admin/payments" && (
          <div>
            {!(
              title === "№" ||
              title === "Сумма" ||
              title === "Дата платежа"
            ) && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "Дата платежа" && (
              <RangePicker
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {(title === "№" || title === "Сумма") && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
          </div>
        )}
        {location.pathname === "/admin/bookings" && (
          <div>
            {!(
              title === "№" ||
              title === "Дата" ||
              title === "Клуб" ||
              title === "Время" ||
              title === "Услуга"
            ) && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "Дата" && (
              <RangePicker
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Время" && (
              <div style={{ display: "flex", gap: "10px" }}>
                <TimePicker
                  placeholder={`Время от`}
                  onChange={(e) => {
                    const fromValue = e
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                  onPressEnter={() => confirm()}
                  style={{
                    marginBottom: 8,
                    width: "100%",
                  }}
                  format={"HH:mm"}
                />
                <TimePicker
                  disabled={!selectedKeys[0]}
                  placeholder={`Время до`}
                  onChange={(e) => {
                    const toValue = e
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                  onPressEnter={() => confirm()}
                  style={{
                    marginBottom: 8,
                    width: "100%",
                  }}
                  format={"HH:mm"}
                />
              </div>
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Услуга" && (
              <Select
                onClick={() => {
                  dispatch(getServices())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={abonementServices?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
          </div>
        )}
        {location.pathname === "/admin/stocks" && (
          <div>
            {title !== "№" && title !== "Клуб" && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
          </div>
        )}
        {location.pathname === "/admin/services" && (
          <div>
            {!(title === "№" || title === "Персональная") && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Персональная" && (
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                options={options}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
          </div>
        )}
        {location.pathname === "/admin/slots" && (
          <div>
            {!(
              title === "№" ||
              title === "Дата" ||
              title === "Клуб" ||
              title === "Время" ||
              title === "Услуга"
            ) && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "Дата" && (
              <RangePicker
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Время" && (
              <div style={{ display: "flex", gap: "10px" }}>
                <TimePicker
                  placeholder={`Время от`}
                  onChange={(e) => {
                    const fromValue = e
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                  onPressEnter={() => confirm()}
                  style={{
                    marginBottom: 8,
                    width: "100%",
                  }}
                  format={"HH:mm"}
                />
                <TimePicker
                  disabled={!selectedKeys[0]}
                  placeholder={`Время до`}
                  onChange={(e) => {
                    const toValue = e
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                  onPressEnter={() => confirm()}
                  style={{
                    marginBottom: 8,
                    width: "100%",
                  }}
                  format={"HH:mm"}
                />
              </div>
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Услуга" && (
              <Select
                onClick={() => {
                  dispatch(getServices())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={abonementServices?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
          </div>
        )}
        {location.pathname === "/admin/schedule" && (
          <div>
            {!(
              title === "№" ||
              title === "Дата" ||
              title === "Клуб" ||
              title === "Время" ||
              title === "Услуга" ||
              title === "Цена"
            ) && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "Дата" && (
              <RangePicker
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Время" && (
              <div style={{ display: "flex", gap: "10px" }}>
                <TimePicker
                  placeholder={`Время от`}
                  onChange={(e) => {
                    const fromValue = e
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                  onPressEnter={() => confirm()}
                  style={{
                    marginBottom: 8,
                    width: "100%",
                  }}
                  format={"HH:mm"}
                />
                <TimePicker
                  disabled={!selectedKeys[0]}
                  placeholder={`Время до`}
                  onChange={(e) => {
                    const toValue = e
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                  onPressEnter={() => confirm()}
                  style={{
                    marginBottom: 8,
                    width: "100%",
                  }}
                  format={"HH:mm"}
                />
              </div>
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Услуга" && (
              <Select
                onClick={() => {
                  dispatch(getServices())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={abonementServices?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Цена" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
          </div>
        )}
        {location.pathname === "/admin/gyms" && (
          <div>
            {title !== "№" && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
          </div>
        )}
        {location.pathname === "/admin/trainings" && (
          <div>
            {!(title === "№" || title === "Клуб") && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
          </div>
        )}
        {location.pathname === "/admin/galery" && (
          <div>
            {!(title === "№" || title === "Клуб") && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
          </div>
        )}

        {location.pathname === "/admin/clubTypes" && (
          <div>
            {title === "Наименование" && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
          </div>
        )}

        {location.pathname === "/admin/personalPackets" && (
          <div>
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Тренер" && (
              <Select
                onClick={() => {
                  dispatch(getTrainers())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={trainersList?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder={`Выбрать ${title.toLowerCase()}`}
              />
            )}
            {title === "Покупаемо с" && (
              <DatePicker
                placeholder={`Искать ${title}`}
                onChange={(date) => {
                  setSelectedKeys(date ? [date] : []) // wrap in array
                  // confirm();
                }}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Покупаемо до" && (
              <DatePicker
                placeholder={`Искать ${title}`}
                onChange={(date) => {
                  setSelectedKeys(date ? [date] : []) // wrap in array
                  // confirm();
                }}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}

            {title === "Цена" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
          </div>
        )}

        {location.pathname === "/admin/personalTrainings" && (
          <div>
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Пользователь" && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "Тренер" && (
              <Select
                onClick={() => {
                  dispatch(getTrainers())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={trainersList?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder={`Выбрать ${title.toLowerCase()}`}
              />
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder={`Выбрать ${title.toLowerCase()}`}
              />
            )}
            {title === "Услуга" && (
              <Select
                onClick={() => {
                  dispatch(getServices())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={abonementServices?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder={`Выбрать ${title.toLowerCase()}`}
              />
            )}
            {title === "Оплачено" && (
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                options={yesNoOpt}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder={`Выбрать ${title.toLowerCase()}`}
              />
            )}
            {title === "Проведено" && (
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                options={yesNoOpt}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder={`Выбрать ${title.toLowerCase()}`}
              />
            )}
            {title === "Дата записи" && (
              <RangePicker
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Цена" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Занятие" && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "Телефон пользователя" && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "№ набора" && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                type='number'
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
          </div>
        )}
        {location.pathname === "/admin/employWorktimes" && (
          <div>
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Сотрудник" && (
              <Select
                onClick={() => {
                  dispatch(getTrainers())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={trainersList?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder={`Выбрать ${title.toLowerCase()}`}
              />
            )}
            {title === "День недели" && (
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                options={[
                  { label: "Понедельник", value: 1 },
                  { label: "Вторник", value: 2 },
                  { label: "Среда", value: 3 },
                  { label: "Четверг", value: 4 },
                  { label: "Пятница", value: 5 },
                  { label: "Суббота", value: 6 },
                  { label: "Воскресенье", value: 7 },
                ]}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder={`Выбрать ${title.toLowerCase()}`}
              />
            )}
            {title === "Время работы от" && (
              <TimePicker
                placeholder={`Искать ${title}`}
                onChange={(date) => {
                  setSelectedKeys(date ? [date.format("HH:mm")] : []) // wrap in array
                  // confirm();
                }}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
            {title === "Время работы до" && (
              <TimePicker
                placeholder={`Искать ${title}`}
                onChange={(date) => {
                  setSelectedKeys(date ? [date.format("HH:mm")] : []) // wrap in array
                  // confirm();
                }}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
          </div>
        )}

        {location.pathname === "/admin/packetsServices" && (
          <div>
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Наименование услуги" && (
              <Select
                onClick={() => {
                  dispatch(getServices())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={services?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder={`Выбрать ${title.toLowerCase()}`}
              />
            )}
            {title === "Количество тренировок" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}

            {title === "Цена пакета" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
          </div>
        )}

        {location.pathname === "/admin/certificates" && (
          <div>
            {title !== "Доступен до" &&
              title !== "Использован" &&
              title !== "Использован кем" && (
                <Input
                  ref={searchInput}
                  placeholder={`Искать ${title}`}
                  value={selectedKeys[0]}
                  onChange={(e) =>
                    setSelectedKeys(e.target.value ? [e.target.value] : [])
                  }
                  onPressEnter={() => confirm()}
                  style={{
                    marginBottom: 8,
                    display: "block",
                  }}
                />
              )}

            {title === "Доступен до" && (
              <RangePicker
                placeholder={["Дата от", "Дата до"]}
                onChange={(dates) => {
                  if (dates) {
                    setSelectedKeys([dates])
                  } else {
                    setSelectedKeys([])
                  }
                }}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  width: "100%",
                }}
              />
            )}

            {title === "Использован" && (
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                options={[
                  { label: "Использовано", value: true },
                  { label: "Не использован", value: false },
                ]}
                onChange={(value) => setSelectedKeys([value])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
                allowClear
              />
            )}

            {title === "Использован кем" && (
              <Input
                ref={searchInput}
                placeholder={`Искать по номеру`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
          </div>
        )}
        {location.pathname === "/subscribes/paymentReminders" && (
          <Input
            ref={searchInput}
            placeholder={`Искать ${title}`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{
              marginBottom: 8,
              display: "block",
            }}
          />
        )}

        {location.pathname === "/account/users" && (
          <div>
            {!(
              title === "№" ||
              title === "Активность" ||
              title === "Роль" ||
              title === "Клуб"
            ) && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "Активность" && (
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                options={options}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Роль" && (
              <Select
                onClick={() => {
                  dispatch(getRoles())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={roles?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
          </div>
        )}
        {location.pathname === "/account/permissions" && (
          <div>
            {!(title === "№" || title === "Клуб" || title === "Роль") && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
          </div>
        )}
        {location.pathname === "/versions" && (
          <div>
            {!(
              title === "№" ||
              title === "Дата версии" ||
              title === "Обязательное"
            ) && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "№" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Обязательное" && (
              <div>
                <Select
                  style={{ width: "100%", marginBottom: "8px" }}
                  options={options}
                  onChange={(e) => setSelectedKeys([e])}
                  value={selectedKeys[0]}
                  placeholder='Выбрать'
                />
              </div>
            )}
            {title === "Дата версии" && (
              <RangePicker
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}
          </div>
        )}
        {location.pathname === "/subscribes/cancelSubscribes" && (
          <div>
            {!(
              title === "Токен" ||
              title === "Сумма" ||
              title === "Дата начала" ||
              title === "Клуб" ||
              title === "Абонемент" ||
              title === "Платежная система"
            ) && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
            {title === "Сумма" && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Input
                  placeholder='От'
                  type='number'
                  onChange={(e) => {
                    const fromValue = e.target.value
                    const toValue = selectedKeys[1]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
                <Input
                  placeholder='До'
                  type='number'
                  disabled={!selectedKeys[0]}
                  onChange={(e) => {
                    const toValue = e.target.value
                    const fromValue = selectedKeys[0]
                    setSelectedKeys([fromValue, toValue])
                  }}
                />
              </div>
            )}
            {title === "Дата начала" && (
              <RangePicker
                placeholder={`Искать ${title}`}
                onChange={setSelectedKeys}
                onPressEnter={() => confirm()}
                style={{
                  marginBottom: 8,
                }}
              />
            )}

            {title === "Абонемент" && (
              <Select
                onClick={() => {
                  dispatch(getAbonements())
                }} //надо поставить фильтр
                style={{ width: "100%", marginBottom: "8px" }}
                options={abonements?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}

            {title === "Платежная система" && (
              <Select
                onClick={() => {
                  dispatch(getPaymentSystem())
                }} //надо поставить фильтр
                style={{ width: "100%", marginBottom: "8px" }}
                options={paymentSystems?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}
            {title === "Клуб" && (
              <Select
                onClick={() => {
                  dispatch(getClubs())
                }}
                style={{ width: "100%", marginBottom: "8px" }}
                options={clubs?.data?.value}
                onChange={(e) => setSelectedKeys([e])}
                value={selectedKeys[0]}
                placeholder='Выбрать'
              />
            )}

            {/*{(title === '№') &&*/}
            {/*  <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>*/}
            {/*      <Input*/}
            {/*        placeholder='От'*/}
            {/*        type='number'*/}
            {/*        onChange={(e) => {*/}
            {/*            const fromValue = e.target.value;*/}
            {/*            const toValue = selectedKeys[1];*/}
            {/*            setSelectedKeys([fromValue, toValue]);*/}
            {/*        }}*/}
            {/*      />*/}
            {/*      <Input*/}
            {/*        placeholder='До'*/}
            {/*        type='number'*/}
            {/*        disabled={!selectedKeys[0]}*/}
            {/*        onChange={(e) => {*/}
            {/*            const toValue = e.target.value;*/}
            {/*            const fromValue = selectedKeys[0];*/}
            {/*            setSelectedKeys([fromValue, toValue]);*/}
            {/*        }}*/}
            {/*      />*/}
            {/*  </div>*/}
            {/*}*/}
          </div>
        )}
        <Space>
          <Button
            type='primary'
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size='small'
            style={{
              width: 90,
            }}
          >
            Поиск
          </Button>
          <Button
            onClick={() => {
              if (clearFilters) {
                handleReset(clearFilters, confirm)
              }
            }}
            size='small'
            style={{
              width: 90,
            }}
          >
            Сбросить
          </Button>
          <Button
            type='link'
            size='small'
            onClick={() => {
              close()
            }}
          >
            Закрыть
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (
      filtered, // значек поиска
    ) =>
      searchble && (
        <SearchOutlined
          style={{
            color: filtered ? "#1677ff" : undefined,
          }}
        />
      ),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100)
      }
    },
    render: (text) => text,
  })

  const [markedClients, setMarkedClients] = useState([])

  let arr = []

  const pushInClientArr = (record) => {
    //
    const isSelected = clientMarkedList.includes(record.id)
    if (isSelected) {
      arr = clientMarkedList.filter((clientId) => clientId !== record.id)
      setMarkedClients(arr)
      setClientMarkedList(arr)
    } else {
      arr = [...clientMarkedList, record.id]
      setMarkedClients(arr)
      setClientMarkedList(arr)
    }
  }
  // useEffect(() => {
  //     if(!checkers){
  //         setClientMarkedList([])
  //         // setClientMarkedList([])
  //     }
  // }, [checkers])

  if (items.length !== 0) {
    return (
      <div style={{ overflowX: "auto" }}>
        {checkers ? (
          <Table
            scroll={scroll ? scroll : { x: 0, y: height }}
            size='small'
            tableLayout='fixed'
            loading={loading}
            bordered
            columns={
              columns &&
              columns.data &&
              columns.data.value &&
              columns.data.value.columns
                ? [
                    ...columns.data.value.columns.map((element) => ({
                      ...element,
                      ...getColumnSearchProps(element.dataIndex, element.title),
                    })),
                    {
                      title: "Действия",
                      key: "action",
                      align: "center",
                      render: (_, record) => {
                        return (
                          <Dropdown
                            disabled={isDeleted}
                            menu={{
                              items,
                            }}
                          >
                            <a
                              onMouseEnter={() => {
                                if (location.pathname === "/account/users") {
                                  onClickRowOne(record)
                                } else if (
                                  location.pathname === "/account/permissions"
                                ) {
                                  onClickRowOne(record)
                                }
                              }}
                              className='text-primary text-decoration-none'
                            >
                              Действия <DownOutlined />
                            </a>
                          </Dropdown>
                        )
                      },
                      width: 100,
                    },
                    // checkers === true ?
                    {
                      title: "Выборка",
                      key: "action",
                      align: "center",
                      render: (_, record) => {
                        if (checkers) {
                          return (
                            <Checkbox
                              onClick={(e) => e.stopPropagation()}
                              onChange={() => pushInClientArr(record)}
                              checked={
                                allActive
                                  ? !clientMarkedList.includes(record.id)
                                  : clientMarkedList.includes(record.id)
                              }
                            ></Checkbox>
                          )
                        }
                      },
                      width: 100,
                    },
                    // : {}
                  ]
                : []
            }
            dataSource={rows}
            title={title}
            pagination={{
              position: ["bottomRight"],
              pageSizeOptions: [20, 40, 60, 80],
              defaultPageSize: pageSize,
              onChange: (page, pageSize) => {
                setPage(page)
                setPageSize(pageSize)
              },
              defaultCurrent: page,
              total: total,
              current: page,
            }}
            onRow={(record, rowIndex) => {
              return {
                onClick: () => {
                  onClickRowOne(record)
                },
              }
            }}
            onChange={onChange}
            rowClassName={rowClassName}
          />
        ) : (
          <Table
            scroll={scroll ? scroll : { x: 0, y: height }}
            size='small'
            tableLayout='fixed'
            loading={loading}
            bordered
            columns={
              columns &&
              columns.data &&
              columns.data.value &&
              columns.data.value.columns
                ? [
                    ...columns.data.value.columns.map((element) =>
                      element.sorter
                        ? {
                            ...element,
                            ...getColumnSearchProps(
                              element.dataIndex,
                              element.title,
                            ),
                          }
                        : {
                            ...element,
                          },
                    ),
                    {
                      title: "Действия",
                      key: "action",
                      align: "center",
                      render: (_, record) => {
                        return (
                          <Dropdown
                            disabled={isDeleted}
                            menu={{
                              items,
                            }}
                          >
                            <a
                              onMouseEnter={() => {
                                if (location.pathname === "/account/users") {
                                  onClickRowOne(record)
                                } else if (
                                  location.pathname === "/account/permissions"
                                ) {
                                  onClickRowOne(record)
                                }
                              }}
                              className='text-primary text-decoration-none'
                            >
                              Действия <DownOutlined />
                            </a>
                          </Dropdown>
                        )
                      },
                      width: 100,
                    },
                    // checkers === true ?
                    // {
                    //     title: 'Выборка',
                    //     key: 'action',
                    //     align: 'center',
                    //     render: (_, record) => {
                    //         if(checkers){
                    //             return (
                    //                 <Checkbox>

                    //                 </Checkbox>
                    //             )
                    //         }
                    //     },
                    //     width: 100
                    // }
                    // : {}
                  ]
                : []
            }
            dataSource={rows}
            title={title}
            pagination={{
              position: ["bottomRight"],
              pageSizeOptions: [20, 40, 60, 80],
              defaultPageSize: pageSize,
              onChange: (page, pageSize) => {
                setPage(page)
                setPageSize(pageSize)
              },
              defaultCurrent: page,
              total: total,
              current: page,
            }}
            onRow={(record, rowIndex) => {
              return {
                onClick: () => {
                  onClickRowOne(record)
                },
              }
            }}
            onChange={onChange}
            rowClassName={rowClassName}
          />
        )}
      </div>
    )
  } else {
    return (
      <div style={{ overflowX: "auto" }}>
        {checkers ? (
          <Table
            scroll={scroll ? scroll : { x: 0, y: height }}
            size='small'
            tableLayout='fixed'
            loading={loading}
            bordered
            columns={
              columns &&
              columns.data &&
              columns.data.value &&
              columns.data.value.columns
                ? [
                    ...columns.data.value.columns.map((element) => ({
                      ...element,
                      ...getColumnSearchProps(element.dataIndex, element.title),
                    })),
                    // checkers === true ?
                    {
                      title: "Выборка",
                      key: "action",
                      align: "center",
                      render: (_, record) => {
                        if (checkers) {
                          return (
                            <Checkbox
                              onClick={(e) => e.stopPropagation()}
                              onChange={() => pushInClientArr(record)}
                              checked={
                                allActive
                                  ? !clientMarkedList.includes(record.id)
                                  : clientMarkedList.includes(record.id)
                              }
                            ></Checkbox>
                          )
                        }
                      },
                      width: 100,
                    },
                    // : {}
                  ]
                : []
            }
            dataSource={rows}
            title={title}
            pagination={{
              position: ["bottomRight"],
              pageSizeOptions: [20, 40, 60, 80],
              defaultPageSize: pageSize,
              onChange: (page, pageSize) => {
                setPage(page)
                setPageSize(pageSize)
              },
              defaultCurrent: page,
              total: total,
              current: page,
            }}
            onRow={(record, rowIndex) => {
              return {
                onClick: () => {
                  onClickRowOne(record)
                },
              }
            }}
            onChange={onChange}
            rowClassName={rowClassName}
          />
        ) : (
          <Table
            scroll={scroll ? scroll : { x: 0, y: height }}
            size='small'
            tableLayout='fixed'
            loading={loading}
            bordered
            columns={
              columns &&
              columns.data &&
              columns.data.value &&
              columns.data.value.columns
                ? [
                    ...columns.data.value.columns.map((element) =>
                      element.sorter
                        ? {
                            ...element,
                            ...getColumnSearchProps(
                              element.dataIndex,
                              element.title,
                            ),
                          }
                        : {
                            ...element,
                          },
                    ),
                    // checkers === true ?
                    // {
                    //     title: 'Выборка',
                    //     key: 'action',
                    //     align: 'center',
                    //     render: (_, record) => {
                    //         if(checkers){
                    //             return (
                    //                 <Checkbox>

                    //                 </Checkbox>
                    //             )
                    //         }
                    //     },
                    //     width: 100
                    // }
                    // : {}
                  ]
                : []
            }
            dataSource={rows}
            title={title}
            pagination={{
              position: ["bottomRight"],
              pageSizeOptions: [20, 40, 60, 80],
              defaultPageSize: pageSize,
              onChange: (page, pageSize) => {
                setPage(page)
                setPageSize(pageSize)
              },
              defaultCurrent: page,
              total: total,
              current: page,
            }}
            onRow={(record, rowIndex) => {
              return {
                onClick: () => {
                  onClickRowOne?.(record)
                },
              }
            }}
            onChange={onChange}
            rowClassName={rowClassName}
          />
        )}
      </div>
    )
  }
}

export default AdminTable
